<template>
  <v-container
    fluid
    class="pa-0"
    >
    <bull-finder-lite-container />
  </v-container>
</template>

<script>
import BullFinderLiteContainer from '../components/BullFinderLiteContainer'

export default {
  name: 'BullFinderLiteMini',
  components: {
    BullFinderLiteContainer
  }
}
</script>